<template>
    <v-row align="center" justify="center"
           class="login-view">
        <v-col sm="8" md="4" xl="3">
            <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        DayToDay - {{ isRestorePassword ? 'Восстановление пароля' : 'Вход' }}
                    </v-toolbar-title>
                </v-toolbar>
                <div v-show="!isRestorePassword">
                    <LoginForm>
                        <div class="text-right">
                            <a class="v-label--clickable text-primary text-subtitle-1"
                               @click="isRestorePassword = true">Забыли пароль?</a>
                        </div>
                    </LoginForm>
                </div>

                <div v-show="isRestorePassword">
                    <v-form ref="restorePasswordForm"
                            @keyup.enter="restorePassword"
                            @submit.prevent>
                        <div v-show="!isRestorePasswordSuccess">
                            <v-card-text class="pb-0">
                                <div class="mb-2 text-body-1">
                                    Для восстановления пароля введите Email или логин.
                                    <br />
                                    Вам будет отправлено письмо со ссылкой на изменение пароля.
                                </div>

                                <v-text-field autofocus
                                              clearable
                                              v-model.trim="login"
                                              :rules="loginRules"
                                              type="text"
                                              name="email"
                                              label="Логин/Email"
                                              placeholder="Логин/Email"
                                              autocomplete="email"
                                              prepend-icon="mdi-account" />
                            </v-card-text>

                            <v-card-actions class="mb-2">
                                <v-spacer />
                                <v-btn type="button"
                                       @click="isRestorePassword = false"
                                       variant="elevated"
                                       color="secondary">Отмена</v-btn>
                                <v-btn class="mr-2"
                                       type="button"
                                       @click="restorePassword"
                                       :disabled="!isValid"
                                       variant="elevated"
                                       color="primary">OK</v-btn>
                            </v-card-actions>
                        </div>

                        <div v-show="isRestorePasswordSuccess">
                            <v-card-text>
                                Вам отправлено письмо для подтверждения сброса пароля.
                            </v-card-text>

                            <v-card-actions class="mb-2">
                                <v-spacer />
                                <v-btn class="mr-2"
                                       type="button"
                                       variant="elevated"
                                       color="grey-darken-3"
                                       @click="isRestorePassword = false">
                                    Вернуться к форме входа
                                </v-btn>
                            </v-card-actions>
                        </div>
                    </v-form>
                </div>
            </v-card>
            <v-card class="elevation-12 mt-4">
                <v-card-text>
                    <v-btn :to="{ name: 'registrationPage' }"
                           class="w-100"
                           type="button"
                           variant="elevated"
                           color="primary">
                        Зарегистрироваться
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import LoginForm from "@/components/LoginForm.vue";

    import DataValidator from "@/common/dataValidator";

    export default {
        components: {
            LoginForm
        },

        data() {
            return {
                login: null,
                loginRules: DataValidator.getLoginRules(),

                isRestorePassword: false,
                isRestorePasswordSuccess: false,
                restorePasswordErrorMessage: "",
                isValidForm: false
            };
        },

        created() {
            this.$store.dispatch("loadPasswordOptions");
        },

        computed: {
            isComplete() {
                return this.login;
            },
            isValid() {
                if (this.isComplete) {
                    this.validateForm();
                }

                return this.isComplete && this.isValidForm;
            }
        },

        methods: {
            async validateForm() {
                if (!this.$refs.restorePasswordForm) {
                    return;
                }

                const { valid } = await this.$refs.restorePasswordForm.validate();

                this.isValidForm = valid;
            },

            restorePassword() {
                if (!this.isValid) {
                    return;
                }

                this.$store.dispatch("sendRestorePasswordEmail", this.login).then(response => {
                    if (response.data.isSuccess) {
                        this.isRestorePasswordSuccess = true;
                        return;
                    }

                    this.restorePasswordErrorMessage = response.data.message;
                });
            }
        }
    };
</script>